<div class="wishlist-toast">
  @if (product$ | async; as currentProduct) {
    <div class="wishlist-toast__card">
      <div class="wishlist-toast__media">
        <sd-media
          class="comparison-toast__image"
          [container]="currentProduct.images?.PRIMARY"
          [alt]="currentProduct.name || 'Товар из избранного'"
          [loading]="'lazy'"
        ></sd-media>
      </div>
      <div class="wishlist-toast__content">
        <div class="wishlist-toast__heading">
          <sd-icon [type]="iconTypes.HEART" class="wishlist-toast__icon"></sd-icon>
          <p class="wishlist-toast__title">добавлено в избранное</p>
        </div>
        <p class="wishlist-toast__product-name">
          {{ currentProduct.name || 'Товар успешно сохранён' }}
        </p>
      </div>
    </div>
  }
</div>
